export default "__VITE_ASSET__a6aBE1Qj__"